<template>
  <div class="heading h-section h-remove-child-margin">
    <p v-if="overTitle" class="heading__suptitle">{{ overTitle }}</p>
    <h1 class="heading__title a-title-huge a-title-huge--800">{{ title }}</h1>
    <p v-if="text" v-html="text"></p>
  </div>
</template>

<script>
export default {
  props: {
    overTitle: {
      type: String
    },
    title: {
      type: String
    },
    text: {
      type: String
    }
  }
}
</script>

<style lang="scss">
@import '../../../LeLab.Web/src/sass/config';

.heading {
  
  &__suptitle,
  &__title {
    margin: 12px 0;
  }

  &__suptitle {
    color: color('primary');
    text-transform: uppercase;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 1px;
  }

  &__title {
    line-height: 1.1;
  }
}
</style>
